module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.11122/js/img/ServiceHub_Icon.svg"